






























import Vue from 'vue';
import {
  HubCard,
  HubSwitch,
} from '@/components/HubComponents';

interface ControlProps {
  like: number;
  views: number;
  autoplay: number;
}

export default Vue.extend({
  name: 'ControlsContainer',

  components: {
    HubCard,
    HubSwitch,
  },

  props: {
    value: {
      type: Object as () => ControlProps,
      default: {
        like: 0,
        views: 0,
        autoplay: 0,
      },
      required: true,
    },
  },

  // computed: {
  //   like: {
  //     get() { return (this as any).value.like; },
  //     set(newValue) {
  //       const newState = Object.assign(this.value, { like: newValue });
  //       return this.$emit('input', newState);
  //     },
  //   },
  // },

  watch: {
    value: {
      handler(newValue) { return this.$emit('input', newValue); },
      deep: true,
    },
  },
});
